export function classifyIncomingPly(incomingPly, currentPly, movePending = false) {
  const incoming = Number(incomingPly ?? 0);
  const current = Number(currentPly ?? 0);

  if (incoming < current) return 'stale';
  if (movePending && incoming <= current) return 'stale';
  if (incoming > current + 1) return 'gap';
  if (incoming === current) return 'duplicate';
  return 'next';
}

export function loadAuthoritativePosition(game, fen) {
  game.load(fen);
  return game;
}

export function parseServerDateTime(value) {
  if (!value) return null;
  if (value instanceof Date) {
    const milliseconds = value.getTime();
    return Number.isFinite(milliseconds) ? milliseconds : null;
  }

  let normalized = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}T/.test(normalized)
    && !/(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized)) {
    normalized += 'Z';
  }
  const milliseconds = Date.parse(normalized);
  return Number.isFinite(milliseconds) ? milliseconds : null;
}
